/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import * as size from '@constant/size';
import * as color from '@constant/color';
import IconBlock from '@component/common/block/icon-block';
import IconTextBlock from '@component/common/block/icon-text-block';
import ImageBlock from '@component/common/block/image-block';
import TextBlock from '@component/common/block/text-block';
import otterReadImage from '@asset/image/otter-read.png';

interface IProps {
  copyText: string;
  goText: string;
  handleGoClick: () => void;
  handleCloseClick: () => void;
}

// ############### styled ###############
const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  padding: ${size.MARGIN_1};
  background-color: ${color.WHITE_1};
  // 글래스모피즘 (애니메이션 중 backdrop-filter 렌더링 충돌로 잠시 비활성)
  // background-color: rgba(255, 255, 255, 0.65);
  // backdrop-filter: blur(10px);
  // -webkit-backdrop-filter: blur(10px);
  border-radius: ${size.BORDER_RADIUS_2};
  box-shadow: ${color.SURFACE_SHADOW};
`;

const CloseButtonContainer = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: ${color.WHITE_1};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${color.SURFACE_SHADOW};
  cursor: pointer;
  z-index: 6;
`;

const CopyBubble = styled.div`
  position: relative;
  background-color: ${color.BROWN_1};
  padding: 6px 12px;
  border-radius: ${size.BORDER_RADIUS_2};
  margin-left: 30px;
  margin-bottom: 8px;

  /* 말풍선 꼬리 (오터 머리 방향) */

  &::after {
    content: '';
    position: absolute;
    left: 12px;
    bottom: -6px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid ${color.BROWN_1};
  }
`;

// ############### component ###############
const OtterNudge: React.FC<IProps> = ({ copyText, goText, handleGoClick, handleCloseClick }) => {
  // ############### handler ###############
  const handleCloseButtonClick = (ev: React.MouseEvent) => {
    ev.stopPropagation();
    handleCloseClick();
  };

  return (
    <Wrapper>
      <CloseButtonContainer onClick={handleCloseButtonClick}>
        <IconBlock icon='close' design={{ icon: { size: 'tiny', color: color.GRAY_1, kind: 'outlined' } }} />
      </CloseButtonContainer>
      <CopyBubble>
        <TextBlock text={copyText} design={{ text: { size: 'small', color: color.WHITE_1, bold: true } }} />
      </CopyBubble>
      <ImageBlock src={otterReadImage} alt='이야기 학습' design={{ image: { width: '80px', height: '80px' } }} />
      <IconTextBlock
        icon='right'
        text={goText}
        click={{ handler: handleGoClick }}
        arrangement='text-icon'
        design={{
          text: { size: 'medium', color: color.BROWN_1, bold: true },
          icon: { size: 'medium', color: color.BROWN_1 },
          box: { right: '10px', bottom: '10px', gap: '0px', event: { cursor: 'pointer' } },
        }}
      />
    </Wrapper>
  );
};

export default OtterNudge;
